const SignUp = () => <div>Sign up</div>

export default SignUp
